import React, { FC, useState } from 'react'

import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'

import cn from 'classnames'

import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'

import { registration_link } from 'utils'

import ButtonNew from 'components/ButtonNew'
import { LogInModal } from 'components/LogInModal'

import { useStore } from 'store'

import styles from './styles.module.scss'

interface IProps {
  boxSX?: SxProps
}

export const UnauthorizedUser: FC<IProps> = ({ boxSX }) => {
  const navigate = useNavigate()
  const [isOpenLogInModal, setIsOpenLogInModal] = useState(false)

  const redirectToRegistrationPage = () => {
    navigate(registration_link())
  }

  const handleOpenLogInModal = () => {
    setIsOpenLogInModal(true)
  }

  const handleCloseLogInModal = () => {
    setIsOpenLogInModal(false)
  }

  return (
    <Box className={styles.unauthorized} sx={boxSX}>
      <ButtonNew
        onClick={redirectToRegistrationPage}
        btnStyleType="style_6"
        btnStyle={{
          height: '40px',
          width: '80px',
          boxShadow: '0px 7px 25px rgba(0, 0, 0, 0.05)',
        }}
        btnText={'Sign up'}
      />
      <ButtonNew
        onClick={handleOpenLogInModal}
        btnStyleType="style_8"
        btnStyle={{
          height: '40px',
          width: '80px',
          boxShadow: '0px 7px 25px rgba(0, 0, 0, 0.05)',
        }}
        btnText={'Log in'}
      />
      {isOpenLogInModal ? (
        <LogInModal
          isOpen={isOpenLogInModal}
          setIsOpen={handleCloseLogInModal}
        />
      ) : null}
    </Box>
  )
}

UnauthorizedUser.displayName = 'UnauthorizedUser'
